import React,{useMemo, useState} from 'react'
import "../RequestCards.css";
import img1 from "../../../assets/Hotels/conference.png";
import button from "../../../assets/icons/ShadowButton.svg";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { baseUrl } from '../../../common/baseUrl';
import { isReviewable } from "../../../common/reviewStatus";

// View Request Card CSS for this 
export default function ConferenceCard(props) {

    const navigate = useNavigate();

    const formattedStatus = useMemo(() => {
        if(props.status==="Declined_Guest"){
            return "Cancelled Guest"
        }
        return props.status.replace('_', ' ');
    }, [props.status]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
        const month = monthNames[date.getMonth()];
        const day = date.getDate();
        return `${month} '${day}`;
    };

    const handleClick = () => {
        navigate(`/requests/${props.requestId}`);
    };


       
    const editReviewModal = ()=>{
        try{
            props.setIsReviewModal(!props.isReviewModal)

            console.log("Booking ID : ",props.bookingId);
            console.log("Booked Room ID : ",props.bookedRoomId);
            console.log("Guest Request ID : ",props.guestRequestId);

            props.setRequestData({
                bookingId: props.bookingId,
                bookedRoomId: props.bookedRoomId,
                guestRequestId: props.guestRequestId,
                ratingRemarks : props?.rating_remark || "",
                rating : props?.rating || 0,
                view : "view"
            })

        }catch(error){
        console.log(error);
        }
    }



  return (
    <>
                <div className='request-card'  onClick={handleClick} >
            <div className='request-card-date'>
                <p>Conference Room</p>
            </div>
            <div className='request-card-main'>
                <div className='request-card-side1'>
                    <div className='request-card-header'>
                    <h4>Conference Room</h4>
                    </div>
                    <div className='request-card-para'>
                        <p style={{ fontSize: '13px', marginTop: '4px' }}>
                            {props.hotelName}
                        </p>
                        <p style={{ fontSize: '11px', marginTop: '4px' }}>
                            {formatDate(props.checkInDate)} - {formatDate(props.checkOutDate)}
                        </p>
                        <p style={{ color: "#ACB8C2", fontSize: '11px', marginTop: '4px' }}>
                            {props.hotelAddress}
                
                        </p>
                        <div className='request-card-checkin'>
                            <div className="request-card-badge">
                                <span>{formattedStatus}</span>
                            </div>
                            {(isReviewable(props.status) && props.is_rating_given) &&  <span className='rate-us' onClick={(e)=>{e.stopPropagation();editReviewModal();}}>view rating</span>}

                        </div>
                    </div>

                    <div className='request-card-button'>
                        <img src={button} alt="Redirect button" />
                    </div>
                </div>
                <div className='request-card-side2'>
                    <div className='request-card-img'>
                    <img src={img1} alt="" />
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}
